import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { useHMSStore, selectPeers, selectIsConnectedToRoom } from "@100mslive/react-sdk";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import { Conference, CallControl } from "../../components/videoCalling";
import { WorkshopContext } from "../../contexts/workshop.context";

export default function OnlineInsightsViewer({ demoWorkshop = false }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [iframeUrl, setIframeUrl] = useState("");
  const isConnected = useHMSStore(selectIsConnectedToRoom);
  
  const [isConferenceVisible, setIsConferenceVisible] = useState(true);

  const { socket } = useContext(WorkshopContext);

  let peers = useHMSStore(selectPeers);

  useEffect(() => {
    if (id) {
      setIframeUrl(`/insights/${id}?${demoWorkshop ? "demo=true" : ""}`);
    }
  }, [id]);

  useEffect(() => {
    // Don't redirect if we're coming from pre-summary
    const isFromPreSummary = location.state?.from === "pre-summary";

    const timeout = setTimeout(() => {
      if (!socket.connected && !isFromPreSummary) {
        navigate(`/insights/${id}`);
      }
    }, 10000); //10 seconds

    return () => clearTimeout(timeout);
  }, [peers, id, socket, location.state]);

  const toggleConference = () => {
    setIsConferenceVisible(!isConferenceVisible);
  };

  return (
    <div className="flex flex-row h-screen w-full">
      <div className="flex-grow relative">
        {iframeUrl && (
          <iframe src={iframeUrl} className="w-full h-full border-none" title="Insights Viewer" />
        )}
       
      </div>
      {isConnected&&<div className="absolute bottom-0 right-0 left-0">
          <CallControl containerClass="relative" />
        </div>
      }
     {isConnected&& <div className={`${isConferenceVisible ? "min-w-40 max-w-40" : "w-12"} h-full overflow-hidden transition-all duration-300 ease-in-out flex flex-col relative`}>
        <div className="p-2 bg-gray-800 flex justify-between items-center">
          <div className="flex gap-1">
            {isConferenceVisible ? (
              <button
                onClick={toggleConference}
                className="text-white p-2 rounded-full text-white-100 hover:bg-gray-700 transition-colors text-xl"
                title="Hide participants">
                <FaChevronRight />
              </button>
            ) : (
              <button
                onClick={toggleConference}
                className="text-white p-2 rounded-full text-white-100 hover:bg-gray-700 transition-colors text-xl"
                title="Show participants">
                <FaChevronLeft />
              </button>
            )}
          </div>
        </div>
        
        <div className="flex-grow overflow-y-auto">
          {isConferenceVisible && <Conference smallSpace={true} demoWorkshop={demoWorkshop} />}
        </div>
      </div>}
    </div>
  );
}
